<template>
    <div class="container-fluid">
        <div class="row mt-3">
        <div class="col-6 col-sm-6 col-md-6">
        <h5>{{ title }}</h5>
        <form @submit.prevent="submit" >
            <div class="form-group" v-if="errors.length" >
                <ul class="list-group">
                    <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
                </ul>
            </div>
            
            <div class="form-group input-group-sm">
                <label>Kupiony przez</label>
                <input class="form-control" disabled v-model="form.createdBy"/>
            </div>
            <div class="form-group input-group-sm">
                <label >Punkt zakupu</label>
                <select class="form-control" v-model="form.storeOfPurchaseId" :disabled="isSoldPhone">
                    <option v-for="option in storesOptions" :key="option.id" v-bind:value="option.id">
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="form-group input-group-sm">
                <label >Punkt w którym znajduje się telefon</label>
                <select class="form-control" v-model="form.actualStoreId" :disabled="isSoldPhone">
                    <option v-for="option in storesOptions" :key="option.id" v-bind:value="option.id">
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="form-group input-group-sm">
                <label >Model telefonu:</label>
                <async-search-input
                    v-bind:uuid="asyncPhoneSearch"
                    v-model="form.phoneNameId"
                    v-bind:dataProvider="phoneNamesDataProvider"
                    v-bind:dataMapper="searchPhoneNamesMapper"
                />
            </div>
            <div class="form-group input-group-sm">
                <label >Kolor telefonu:</label>
                <async-search-input
                    v-bind:uuid="asyncColorSearch"
                    v-model="form.colorId"
                    v-bind:dataProvider="colorsDataProvider"
                    v-bind:dataMapper="searchColorsMapper"
                />
            </div>
            <div class="form-group input-group-sm">
                <label >Kwota zakupu</label>
                <input class="form-control" type="number" min="0" step="any" v-model="form.paidAmount" :disabled="isSoldPhone"/>
            </div>
            <div class="form-group input-group-sm">
                <label >Sugerowana kwota sprzedaży</label>
                <input class="form-control" type="number" min="0" step="any" v-model="form.suggestedPrice" :disabled="isSoldPhone"/>
            </div>
            <div class="form-group input-group-sm">
                <label >Gwarancja</label>
                <div class="custom-control custom-radio">
                    <input type="radio" name="customRadio" class="custom-control-input" id="NoGuarantee"
                        value="NoGuarantee" v-model="guaranteeValue" :disabled="isSoldPhone">
                    <label class="custom-control-label" for="NoGuarantee">Brak gwarancji</label>
                </div>
                <div class="custom-control custom-radio">
                    <input type="radio" name="customRadio" class="custom-control-input" id="DateGuarantee" 
                       value="DateGuarantee" v-model="guaranteeValue" :disabled="isSoldPhone">
                    <label class="custom-control-label" for="DateGuarantee">Gwarnacja do:</label>
                    <div v-if="dateGuaranteeSelected">
                        <datepicker 
                            :disabled="isSoldPhone"
                            class="mt-1 "
                            v-model="guaranteeDateValue"
                            :monday-first="true"
                            :language="lang"
                        ></datepicker>
                    </div>
                </div>
            </div>
            <div class="form-group input-group-sm">
                <label >Simlock</label>
                <select class="form-control" v-model="form.simLock" :disabled="isSoldPhone">
                    <option v-for="option in simLockOptions" :key="option.id" v-bind:value="option.id">
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="form-group input-group-sm">
                <label >Pochodzenie telefonu</label>
                <select class="form-control" v-model="form.phoneOrigin" :disabled="isSoldPhone">
                    <option v-for="option in phoneOriginOptions" :key="option.id" v-bind:value="option.id">
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="form-group input-group-sm">
                <label >Stan telefonu</label>
                <select class="form-control" v-model="form.phoneState" :disabled="isSoldPhone">
                    <option v-for="option in phoneStateOptions" :key="option.id" v-bind:value="option.id">
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="form-group input-group-sm">
                <label >Data zakupu</label>
                <datepicker
                        :disabled="isSoldPhone" 
                        class="mt-1 "
                        v-model="form.dateOfPurchase"
                        :monday-first="true"
                        :language="lang"
                    ></datepicker>
            </div>
            <div class="col-6 col-sm-6 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <div class="col-8 col-sm-8 col-md-8 form-group input-group-sm">
                            <label >Kwota sprzedaży</label>
                            <input class="form-control" type="number" min="0" step="any" v-model="soldForm.soldPrice" :disabled="isSoldPhone"/>
                        </div>
                        <div class="col-8 col-sm-8 col-md-8 form-group input-group-sm">
                            <label >Data sprzedaży</label>
                            <datepicker
                                :disabled="isSoldPhone" 
                                v-model="soldForm.soldDate"
                                :monday-first="true"
                                :language="lang"
                            ></datepicker>
                        </div>
                        <div class="col-8 col-sm-8 col-md-8 form-group input-group-sm">
                            <label >Punkt sprzedaży telefonu</label>
                            <select class="form-control" v-model="soldForm.soldStore" :disabled="isSoldPhone" >
                                <option v-for="option in storesOptions" :key="option.id" v-bind:value="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-8 col-sm-8 col-md-8 form-group input-group-sm" v-if="isSoldPhone">
                            <label >Sprzedany przez</label>
                            <input class="form-control" v-model="soldForm.soldBy" disabled/>
                        </div>
                        <div class="col-3 col-sm-3 col-md-3 form-group input-group-sm" v-if="isAvailablePhone">
                            <button class="btn btn-success torre-btn btn-sm " @click.prevent="soldPhone()">Sprzedaj</button>
                        </div>
                    </div>
                </div>
            </div>
            <input class="btn btn-success torre-btn btn-sm mr-2 mt-3" type="submit" value="Edytuj" v-if="isAvailablePhone">
            <router-link class="btn btn-secondary btn-sm mt-3 mr-2" :to="{ name: 'phones' }">Anuluj</router-link>
            <button class="btn btn-dark btn-sm mt-3" v-if="isAdmin" @click.prevent="deletePhoneConfirm()">Usuń</button>
        </form>
        </div>
        </div>
    </div>
</template>
<script>
import {pl} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import alertify from 'alertifyjs'
import un from 'underscore'
import PhonesService from "@/components/phones/PhonesService"

const phonesService = new PhonesService()

export default {
    components: {
      datepicker 
    },
    name: "PhonesEdit",
    data: function () {
        return {
            asyncPhoneSearch: "asyncPhoneSearch",
            asyncColorSearch: "asyncColorSearch",
            phoneNamesDataProvider: phonesService.searchPhoneNames,
            searchPhoneNamesMapper: phonesService.searchPhoneNamesMapper,
            colorsDataProvider: phonesService.searchColors,
            searchColorsMapper: phonesService.searchColorsMapper,
            errors: [],
            simLockOptions: [],
            phoneStateOptions: [],
            phoneOriginOptions: [],
            storesOptions: [],
            lang: pl,
            guaranteeValue: "",
            guaranteeDateValue: moment().format("YYYY-MM-DD HH:mm:ss"),
            phoneStatus: "",
            soldForm: {
                soldPrice: "",
                soldDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                soldStore: "-1",
                soldBy: ""
            },
            form: {
                createdBy: "",
                phoneNameId: "",
                colorId: "",
                storeOfPurchaseId: -1,
                actualStoreId: -1,
                phoneOrigin: "-1",
                simLock: "-1",
                phoneState: "-1",
                dateOfPurchase: moment().format("YYYY-MM-DD HH:mm:ss"),
                paidAmount: "",
                suggestedPrice: "",
            }
        }
    },
    computed: {
        title() {
            if (this.isSoldPhone) {
                return "Telefon sprzedany"
            }
            if (this.isAvailablePhone) {
                return "Telefon dostępny"
            }
            return ""
        },
        dateGuaranteeSelected() {
            return this.guaranteeValue === "DateGuarantee"
        },
        isSoldPhone() {
            return this.phoneStatus === "SOLD"
        },
        isAvailablePhone() {
            return this.phoneStatus === "AVAILABLE"
        },
        isAdmin() {
            return phonesService.isAdmin()
        }
    },
    created() {
        this.loadConfig()
        this.initStoresOptions()
    },
    methods: {
        deletePhoneConfirm() {
            const that = this
            alertify.confirm('', 'Chcesz usunąć telefon?', function(){
                that.deletePhone()
                }, function(){},
            );
        },
        deletePhone() {
            const id = this.$route.params.id
            phonesService.deletePhone(id, this.onDeleteSuccess, this.onDeleteError)
        },
        onDeleteSuccess(data) {
            this.$router.push({name: 'phones'})
            alertify.set('notifier','position', 'top-center');
            alertify.success("Telefon został usunięty").delay(3);
        },
        onDeleteError(err) {
            console.log(err)
            this.errors = err
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można usunąć telefonu.").delay(3);
        },
        submit() {
            this.clearErrors()
            if (this.isAvailablePhone) {
                const newForm = {
                ...this.form, 
                ...{
                    guarantee: phonesService.parseGuarantee(this.guaranteeValue, this.guaranteeDateValue),
                    id: this.$route.params.id
                    }
                }
                phonesService.editAvailablePhone(newForm, this.onEditAvailablePhoneSuccess, this.onEditAvailablePhoneError)
            }
        },
        onEditAvailablePhoneSuccess(data) {
            this.$router.push({name: 'phones'})
            alertify.set('notifier','position', 'top-center');
            alertify.success("Telefon został zapisany").delay(3);
        },
        onEditAvailablePhoneError(err) {
            console.log(err)
            this.errors = err
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można zedytować telefonu.").delay(3);
        },
        soldPhone() {
            this.clearErrors()
            if (this.isAvailablePhone) {
                const newForm = {
                    uuid: this.$route.params.id,
                    soldPrice: this.soldForm.soldPrice,
                    soldDate: moment(this.soldForm.soldDate).format("YYYY-MM-DD HH:mm:ss"),
                    soldStore: this.soldForm.soldStore
                }
                console.log(newForm)
                phonesService.soldPhone(newForm, this.onSoldPhoneSuccess, this.onSoldPhoneError)
            }
        },
        onSoldPhoneSuccess(data) {
            this.$router.push({name: 'phones'})
            alertify.set('notifier','position', 'top-center');
            alertify.success("Telefon został zapisany").delay(3);
        },
        onSoldPhoneError(err) {
            console.log(err)
            this.errors = err
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można sprzedać telefonu.").delay(3);
        },
        loadPhone() {
            const uuid = this.$route.params.id
            phonesService.findPhone(uuid, this.onLoadPhoneSuccess, this.onLoadPhoneError)
        },
        assertPhoneHasProperStatus(phoneStatus) {
            if (["AVAILABLE", "SOLD"].indexOf(phoneStatus) < 0) {
                this.$router.push({name: 'phones'})
                alertify.set('notifier','position', 'top-center');
                alertify.error("Telefon ma nieobsługiwany status " + phoneStatus).delay(3);
            }
        },
        onLoadPhoneSuccess(data) {
            this.form.createdBy = data.createdBy
            this.assertPhoneHasProperStatus(data.phoneStatus)
            this.phoneStatus = data.phoneStatus
            this.form.phoneNameId = data.phone.id
            this.form.colorId = data.color.id
            this.form.storeOfPurchaseId = data.storeOfPurchase.id,
            this.form.actualStoreId = data.actualStore.id,
            this.form.phoneOrigin = data.phoneOrigin
            this.form.simLock = data.simLock
            this.form.phoneState = data.phoneState
            this.form.dateOfPurchase = moment(data.dateOfPurchase).format("YYYY-MM-DD HH:mm:ss")
            this.form.paidAmount = data.paidAmount
            this.form.suggestedPrice = data.suggestedPrice
            this.soldForm.soldPrice = data.soldPrice || 0
            if (data.dateOfSold) {
                this.soldForm.soldDate = moment(data.dateOfSold).format("YYYY-MM-DD HH:mm:ss")
            }
            if (data.storeOfSold) {
                this.soldForm.soldStore = data.storeOfSold.id
                this.soldForm.soldBy = data.soldBy
            }
            this.setupGuarantee(data.guarantee)
            this.$emit("setAsyncSearchInputData", {...data.phone, ...{uuid:this.asyncPhoneSearch}})
            this.$emit("setAsyncSearchInputData", {...data.color, ...{uuid:this.asyncColorSearch}})
        },
        setupGuarantee(phoneGuarantee) {
            if (phoneGuarantee) {
                this.guaranteeValue = "DateGuarantee"
                this.guaranteeDateValue = moment(phoneGuarantee).format("YYYY-MM-DD HH:mm:ss")
            } else {
                this.guaranteeValue = "NoGuarantee"
            }
        },
        clearErrors() {
            this.errors = []
        },
        onLoadPhoneError(err) {
            console.log(err)
            this.$router.push({name: 'phones'})
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można pobrać telefonu.").delay(3);
        },
        loadConfig() {
            phonesService.loadConfig(this.initView)
        },
        initView(config) {
            this.simLockOptions = phonesService.initOptions(config.SimLock, "-1", "Simlock")
            this.phoneStateOptions = phonesService.initOptions(config.PhoneState, "-1", "PhoneState")
            this.phoneOriginOptions = phonesService.initOptions(config.PhoneOrigin, "-1", "PhoneOrigin")
        },
        initStoresOptions() {
            phonesService.initStores(this.onStoresSuccess)
        },
        onStoresSuccess(data, selectedStore) {
            this.storesOptions = data
            this.form.storeOfPurchaseId = selectedStore.id
            this.loadPhone()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/phones/PhonesEdit.vue